import { ContainerSC } from './StyleContainer'

const Container = ({ children }) => {
    return <ContainerSC>{children}</ContainerSC>
}

export default Container
